import { render, staticRenderFns } from "./CreateItensNotaFiscalView.vue?vue&type=template&id=c54be0ba&scoped=true"
import script from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"
export * from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"
import style0 from "./CreateItensNotaFiscalView.vue?vue&type=style&index=0&id=c54be0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54be0ba",
  null
  
)

export default component.exports